module.exports={__schema:{types:[{kind:"UNION",name:"Data",possibleTypes:[{name:"BinaryData"},{name:"RadarData"},{name:"ScaleData"}]}]}};